export default (function () {
  const $type = String;
  $type.__typeName = 'String';
  $type.__class = true;

  const $prototype = $type.prototype;

  $prototype.endsWith = function String$endsWith(suffix) {
    return this.substr(this.length - suffix.length) === suffix;
  };

  $prototype.startsWith = function String$startsWith(prefix) {
    return this.substr(0, prefix.length) === prefix;
  };

  $prototype.trim = function String$trim() {
    return this.replace(/^\s+|\s+$/g, '');
  };

  $prototype.trimEnd = function String$trimEnd() {
    return this.replace(/\s+$/, '');
  };

  $prototype.trimStart = function String$trimStart() {
    return this.replace(/^\s+/, '');
  };

  $type.format = function String$format() {
    return String._toFormattedString(false, arguments);
  };

  $type._toFormattedString = function String$_toFormattedString(
    useLocale,
    args
  ) {
    let result = '';
    const format = args[0];
    let formatArguments = [];
    if (args.length === 2) {
      formatArguments = args[1];
    } else {
      for (let pos = 1, length = args.length; pos < length; pos++) {
        formatArguments.push(args[pos]);
      }
    }

    for (let i = 0; ; ) {
      const open = format.indexOf('{', i);
      const close = format.indexOf('}', i);
      if (open < 0 && close < 0) {
        result += format.slice(i);
        break;
      }
      if (close > 0 && (close < open || open < 0)) {
        if (format.charAt(close + 1) !== '}') {
          throw new Error('format stringFormatBraceMismatch');
        }

        result += format.slice(i, close + 1);
        i = close + 2;
        continue;
      }

      result += format.slice(i, open);
      i = open + 1;

      if (format.charAt(i) === '{') {
        result += '{';
        i++;
        continue;
      }

      if (close < 0) {
        throw new Error('format stringFormatBraceMismatch');
      }

      const brace = format.substring(i, close);
      const colonIndex = brace.indexOf(':');
      const argNumber = parseInt(
        colonIndex < 0 ? brace : brace.substring(0, colonIndex),
        10
      );

      if (isNaN(argNumber)) {
        throw new Error('format stringFormatInvalid');
      }

      const argFormat = colonIndex < 0 ? '' : brace.substring(colonIndex + 1);

      const arg = formatArguments[argNumber];
      if (!('' + arg)) {
        throw new Error('INVALID NUMBER PARAMETERS');
      }

      if (Number.isInteger(arg)) {
        let r = '' + arg;
        const length = argFormat.length;
        while (r.length < length) {
          r = '0' + r;
        }
        result += r;
      } else if (arg.toFormattedString) {
        result += arg.toFormattedString(argFormat);
      } else if (useLocale && arg.localeFormat) {
        result += arg.localeFormat(argFormat);
      } else if (arg.format) {
        result += arg.format(argFormat);
      } else {
        result += arg.toString();
      }

      i = close + 1;
    }

    return result;
  };

  return $type;
})();
